import React from 'react';
import Hero from '../components/Hero';
import Services from '../components/Services';
import ScrollReveal from '../components/ScrollReveal';
import ScrollProgress from '../components/ScrollProgress';

const Home = () => {
  return (
    <>
      <ScrollProgress />
      <Hero />
      <ScrollReveal animation="fade-up" delay={50}>
        <Services />
      </ScrollReveal>
    </>
  );
};

export default Home;
